import { render, staticRenderFns } from "./NavbarProfessor.vue?vue&type=template&id=3569ffed"
import script from "./NavbarProfessor.vue?vue&type=script&lang=js"
export * from "./NavbarProfessor.vue?vue&type=script&lang=js"
import style0 from "./NavbarProfessor.vue?vue&type=style&index=0&id=3569ffed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports